module.exports = __webpack_public_path__ + "media/video2.a1f17831.mp4";